import {Icon} from './Icon';
import { useLocation } from 'react-router';
import { Link } from './ScopedLink';
import { selectedBuilding } from './building-scope';
import { mailReturnContext,captureLensReturnContext } from './mail-navigation';

export function MailReturnLink() {
  const location = useLocation();
  const lens=captureLensReturnContext(location.state,selectedBuilding(location.pathname,location.search));
  if(lens)return <Link className="back-link" to={lens.to} state={{lensSender:lens.sender}}><Icon name="arrow-left"/> Needs classification</Link>;
  const context = mailReturnContext(location.state, selectedBuilding(location.pathname, location.search));
  return <Link className="back-link" to={context?.to ?? '/communications'}
    state={context ? { mailSearch: context.search, mailFocusKey: context.focusKey } : undefined}><Icon name="arrow-left"/> Mail</Link>;
}
